<template>
   <div class="container">
    <h1>Change Password</h1>
  
      <transition name="fade">
        <p
          class="bg-red-100 p-5 my-5 border border-red-200 rounded text-red-500"
          v-if="error"
        >
          {{ error }}
        </p>
      </transition>
      <v-form @submit.prevent class="login">
          
          <v-text-field
            type="email"
            placeholder="Email address..."
            v-model="email"
            id="email"
            required
          />
      
          <v-btn type="submit" @click="sendEmail" class="primary">
              <transition name="fade" mode="out-in">
              <span v-if="!emailSending">Send</span>
              <span v-else>Sending...</span>
            </transition>
          </v-btn>
      </v-form>
    </div>
</template>

<script>
import firebase from "firebase";
export default {
  data() {
    return {
      email: "",
      error: null,
      emailSending: false,
    };
  },
  methods: {
    sendEmail() {
      if (!this.email) {
        this.error = "Please type in a valid email address.";
        return;
      }
      this.error = null;
      this.emailSending = true;
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.emailSending = false;
          this.$router.push("/");
        })
        .catch((error) => {
          this.emailSending = false;
          this.error = error.message;
        });
    },
  },
};
</script>


<style>
.container {
  max-width: 1140px;
}
h1 {
  font-size: 30px;
}
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  margin: 40px auto;
}
h1 {
  text-align: center;
}
button {
  width: 200px;
  margin: 0 auto;
  margin-top: 20px;
}

p{
  color: red;
}
</style>